<script setup>
import Updates from "@/views/enterprise/home/aside/updates/Updates.vue";
import CompanyDetails from "@/views/enterprise/home/aside/CompanyDetails.vue";
import {useStore} from "vue2-helpers/vuex";
import {inject} from "vue";

const store = useStore();
const collapsed = inject('asideCollapsed');
</script>

<template>
    <aside class="aside" :class="{ 'aside--collapsed': collapsed }">
        <a v-if="store.getters.isDaikinEnterprise" @click="collapsed = !collapsed" class="aside__collapse"></a>

        <div class="aside__inner">
            <div
                class="aside__inner__section"
                :class="{'no-radius': store.getters.isDaikinEnterprise}"
            >
                <CompanyDetails/>
            </div>

            <div
                v-if="store.getters.isPremiumEnterprise"
                class="aside__inner__section"
            >
                <Updates/>
            </div>
        </div>
    </aside>
</template>

<style scoped>
    .aside {
        flex: 0 0 474px !important;
        background-color: inherit !important;
        box-shadow: inherit !important;
        padding: 30px 0 0 0 !important;
        overflow: hidden;

        &.aside--collapsed {
            flex: 0 0 42px !important;

            .aside__collapse::before {
                transform: rotate(0deg);
            }
        }

        .aside__collapse {
            display: flex;
            align-items: center;
            justify-content: center;
            align-self: flex-start;
            flex: 0 0 42px;
            width: 42px;
            height: 53px;
            background: #016d94;
            border-radius: 26px 0 0 26px;
            cursor: pointer;

            &::before {
                content: "";
                display: block;
                width: 12px;
                height: 12px;
                background: url('../../../../images/minimize.svg') no-repeat center;
                background-size: auto 12px;
                transform: rotate(180deg);
            }
        }

        .aside__inner {
            flex: 0 0 432px;
            width: 432px;

            .aside__inner__section {
                background-color: #fff;
                font-weight: bold;
                border-radius: 10px;
                border: solid 1px #ddd;

                &.no-radius {
                    border-top-left-radius: 0;
                }
            }
        }
    }
</style>
